<template>
  <div class="page">
    <div class="headerNav">
      <div class="nav">
        <div class="nav_content">详情</div>
      </div>
      <div class="nav-left" @click="goBack"><img src="../../assets/new/left_b.svg" alt="" /></div>
    </div>
    <div class="group_1" v-if="index">
      <div class="title">
        {{ detail.title || '' }}
      </div>
      <div class="time">发布时间：{{ detail.publishTime ? detail.publishTime.split(' ')[0] : '' }}</div>
      <div class="content" v-html="detail.infoContent"></div>
    </div>

    <div class="group_1" v-if="!index">
      <div class="title">
        {{ detail2.picTitle || '' }}
      </div>

      <!-- 判断 picDesc 是否是链接 -->
      <div class="content">
        <div v-if="isUrl(detail2.picDesc)">
          <a :href="detail2.picDesc" target="_blank" rel="noopener noreferrer">{{ detail2.picDesc }}</a>
        </div>
        <div v-else v-html="detail2.picDesc"></div>
      </div>

      <!-- <div v-if="detail2.picUrl">
        <img :src="detail2.picUrl" alt="" style="width: 100%; height: auto" />
      </div> -->
    </div>
  </div>
</template>
<script>
// 这里可以导入其他文件（比如：组件，工具js，第三方插件js，json文件，图片文件等等）
// 例如：import 《组件名称》 from '《组件路径》';
// import { get } from 'core-js/core/dict';
import { toInfoMessageDetail, tofindPictureDetail } from '../../api/index';

export default {
  // import引入的组件需要注入到对象中才能使用
  components: {},
  data() {
    // 这里存放数据
    return {
      infoId: '',
      detail: {},
      detail2: {},
      index: true //判断是详情还是轮播图
    };
  },
  // 监听属性 类似于data概念
  computed: {},
  // 监控data中的数据变化
  watch: {},
  // 方法集合
  methods: {
    isUrl(str) {
      try {
        new URL(str);
        return true;
      } catch (e) {
        return false;
      }
    },
    getDetail() {
      toInfoMessageDetail({ infoId: this.$route.query.id }).then(res => {
        this.detail = res.data.data;
      });
    },
    //轮播图的详情
    getswip() {
      const data = {
        picId: this.$route.query.id
      };
      tofindPictureDetail(data).then(res => {
        console.log(res.data);
        this.detail2 = res.data.data;
      });
    },
    goBack() {
      if (this.$route.query.index == 1) {
        this.$router.push({
          path: '/'
        });
      } else if (this.$route.query.index == 2) {
        this.$router.push({
          path: '/announcement',
          query: {
            item: 'a'
          }
        });
      }else if (this.$route.query.index == 3){
         this.$router.push({
          path: '/announcement',
          query: {
            item: 'b'
          }
        });
      }else{
           this.$router.push({
          path: '/announcement',
          query: {
            item: 'a'
          }
        });
      }
    }
  },
  // 生命周期 - 创建完成（可以访问当前this实例）
  created() {
    if (this.$route.query.index==1) {
      this.index = false;
      this.getswip();
    } else {
      this.getDetail();
    }

    window.scrollTo(0, 0);
  },
  // 生命周期 - 挂载完成（可以访问DOM元素）
  mounted() {},
  beforeCreate() {}, // 生命周期 - 创建之前
  beforeMount() {} // 生命周期 - 挂载之前
};
</script>
<style lang="less" scoped>
/* //@import url(); 引入公共css类 */
.page {
  background-color: #f6f8fa;
  height: 100vh;
  overflow-y: scroll;
}
.group_1 {
  padding: 50px 15px;
}
.title {
  font-family: PingFang SC, PingFang SC;
  font-weight: 500;
  font-size: 18px;
  color: #333333;
  margin-top: 20px;
  text-align: center;
}
.time {
  font-family: PingFang SC, PingFang SC;
  font-weight: 400;
  font-size: 13px;
  color: #999999;
  margin-top: 8px;
}
.content {
width: 100%;
  font-family: PingFang SC, PingFang SC;
  font-weight: 400;
  font-size: 15px;
  color: #333333;
  margin-top: 20px;
  margin-bottom: 20px;
   :deep(img) {
    width: 100%;
    height: auto;
      }
  
}
.headerNav {
  position: fixed;
  top: 0;
  width: 100%;
  height: 46px;
  background: #fff;
  border-radius: 0px 0px 0px 0px;
  z-index: 99;
}
.nav {
  padding: 0 15px;
  height: 46px;
  width: 100%;
  display: flex;
  align-items: center;
  justify-content: center;
  position: relative;
}
.nav-left {
  position: absolute;
  top: 15px;
  left: 15px;
}
.nav_content {
  font-family: PingFang SC, PingFang SC;
  font-weight: 600;
  font-size: 17px;
  color: #333;
}
</style>
